import { useTranslation } from 'react-i18next';
import './Features.css';

const ICONS = {
  agenda: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="14" r="1" fill="currentColor"/>
      <circle cx="8" cy="17" r="1" fill="currentColor"/>
      <path d="M11 14h7M11 17h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  notes: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M5 3h11l4 4v14H5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M16 3v4h4M9 12h7M9 16h7M9 8h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  agreements: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 2L4 5v6c0 5 4 9 8 11 4-2 8-6 8-11V5l-8-3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  ),
  planner: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <rect x="7" y="8" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="7" y="14" width="4" height="4" rx="1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M13 9h5M13 16h5M13 12h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  history: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 12a9 9 0 016-8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  pending: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="8" cy="12" r="1" fill="currentColor"/>
      <circle cx="12" cy="12" r="1" fill="currentColor"/>
      <circle cx="16" cy="12" r="1" fill="currentColor"/>
    </svg>
  ),
};

const ITEMS = ['agenda', 'notes', 'agreements', 'planner', 'history', 'pending'] as const;

export function Features() {
  const { t } = useTranslation();

  return (
    <section id="features" className="section">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">{t('features.eyebrow')}</span>
          <h2>{t('features.title')}</h2>
          <p>{t('features.subtitle')}</p>
        </div>
        <div className="features-grid">
          {ITEMS.map((key) => (
            <article key={key} className="feature">
              <span className="feature__icon">{ICONS[key]}</span>
              <h3 className="feature__title">{t(`features.items.${key}.title`)}</h3>
              <p className="feature__body">{t(`features.items.${key}.body`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
